import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { TtlBadge } from "@/components/domain/dns/ttl-badge";
import { KeyValue } from "@/components/domain/key-value";
import { Favicon } from "@/components/icons/favicon";
import type { DnsRecord } from "@domainstack/types";
import { ResponsiveTooltip, ResponsiveTooltipContent, ResponsiveTooltipTrigger } from "@domainstack/ui/responsive-tooltip";
export function DnsRecordList(t0) {
  const $ = _c(12);
  const {
    records,
    type
  } = t0;
  let t1;
  if ($[0] !== records || $[1] !== type) {
    let t2;
    if ($[3] !== type) {
      t2 = r => r.type === type;
      $[3] = type;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = records.filter(t2);
    $[0] = records;
    $[1] = type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const arr = t1;
  const filtered = arr;
  let t2;
  if ($[5] !== filtered || $[6] !== type) {
    let t3;
    if ($[8] !== type) {
      t3 = r_0 => <KeyValue key={`${type}-${r_0.value}${type === "MX" ? `-${r_0.priority ?? ""}` : ""}`} label={type === "MX" && r_0.priority != null ? `Priority ${r_0.priority}` : undefined} value={r_0.value} trailing={typeof r_0.ttl === "number" ? <TtlBadge ttl={r_0.ttl} /> : undefined} suffix={r_0.isCloudflare ? <ResponsiveTooltip><ResponsiveTooltipTrigger nativeButton={false} render={<span><Favicon domain="cloudflare.com" /></span>} /><ResponsiveTooltipContent><p>Real IP is being concealed using Cloudflare.</p></ResponsiveTooltipContent></ResponsiveTooltip> : undefined} />;
      $[8] = type;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = filtered.map(t3);
    $[5] = filtered;
    $[6] = type;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[10] !== t2) {
    t3 = <>{t2}</>;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}